"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const settlementRequestDataState_1 = __importDefault(require("@/room/settlement_request/settlementRequestDataState"));
const showCompanyRegisterDialogState_1 = __importDefault(require("@/common/components/CompanyRegisterDialog/showCompanyRegisterDialogState"));
const userInfoState_1 = __importDefault(require("@/common/components/NavHeader/userInfoState"));
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const material_ui_confirm_1 = require("material-ui-confirm");
const functions_1 = require("./functions");
const _1 = require(".");
function default_1({ handleSubmit, setValue, settlementRequestType, }) {
    const isPaymentRequest = settlementRequestType === 'payment';
    const isCommissionWithdraw = settlementRequestType === 'commission';
    const [settlementRequestData, setSettlementRequestData] = (0, recoil_1.useRecoilState)(settlementRequestDataState_1.default);
    const { channel_id } = (0, recoil_1.useRecoilValue)(userInfoState_1.default);
    const setShowCompanyRegisterDialog = (0, recoil_1.useSetRecoilState)(showCompanyRegisterDialogState_1.default);
    const openCompanyRegisterDialog = () => setShowCompanyRegisterDialog(true);
    const [showPublishAgreeDialog, setShowPublishAgreeDialog] = (0, react_1.useState)(false);
    const openPublishAgreeDialog = () => setShowPublishAgreeDialog(true);
    const closePublishAgreeDialog = () => setShowPublishAgreeDialog(false);
    const commissionOrderId = isCommissionWithdraw
        ? Number(window.location.pathname.split('/').pop())
        : 0;
    const [postUrl, returnUrl] = (0, functions_1.getSettlementRequestPostReturnUrl)({
        settlementRequestType,
        roomId: settlementRequestData.id,
        commissionOrderId,
    });
    const isSettlementDisabled = (0, functions_1.getIsSettlementDisabled)({
        settlementRequestType,
        settlementRequestData,
    });
    const { t } = (0, react_i18next_1.useTranslation)();
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const [isRequesting, setIsRequesting] = (0, react_1.useState)(false);
    const submitSettlementRequest = (inputData) => __awaiter(this, void 0, void 0, function* () {
        setIsRequesting(true);
        const { tax_type } = inputData;
        const updates = (0, functions_1.generateSettlementRequestUpdates)({
            settlementRequestType,
            settlementRequestData,
            inputData,
            commissionOrderId,
        });
        yield (0, api_1.postData)(postUrl, updates)
            .then(() => {
            (0, functions_1.saveTaxType)({ channel_id, tax_type: tax_type !== null && tax_type !== void 0 ? tax_type : 0 });
            window.location.href = returnUrl;
        })
            .catch(error => {
            (0, _1.handleSettlementRequestSubmitError)({
                error,
                confirm,
                returnUrl,
                setSettlementRequestData,
                setValue,
                openCompanyRegisterDialog,
                openPublishAgreeDialog,
            });
            setIsRequesting(false);
        });
    });
    const checkSettlementRequest = handleSubmit((inputData) => __awaiter(this, void 0, void 0, function* () {
        if (!isRequesting) {
            if (isPaymentRequest) {
                confirm({
                    description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('PG사 요청으로 정산 받은 금액은'), (0, jsx_runtime_1.jsx)("br", {}), t('판매무산 기능을 이용할 수 없어요.'), (0, jsx_runtime_1.jsx)("br", {}), t('진행하시겠어요?')] })),
                    confirmationText: t('정산 접수'),
                })
                    .then(() => __awaiter(this, void 0, void 0, function* () { return yield submitSettlementRequest(inputData); }))
                    .catch(() => { });
            }
            else {
                yield submitSettlementRequest(inputData);
            }
        }
    }));
    const onSettlementRequestSubmit = handleSubmit((inputData) => __awaiter(this, void 0, void 0, function* () {
        if (inputData.tax_type === 2) {
            if (!settlementRequestData.company_post_code) {
                (0, _1.companyInfoErrorConfirm)({ confirm, openCompanyRegisterDialog });
                return;
            }
            else if (!settlementRequestData.channel_company_seller_publish_agree) {
                openPublishAgreeDialog();
                return;
            }
        }
        yield checkSettlementRequest();
    }));
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(_1.SettlementRequestSubmitButton, { isSettlementDisabled: isSettlementDisabled, isRequesting: isRequesting, request_amount: settlementRequestData.request_amount, onSettlementRequestSubmit: onSettlementRequestSubmit }), (0, jsx_runtime_1.jsx)(_1.SettlementRequestSellerPublishAgree, { open: showPublishAgreeDialog, closeDialog: closePublishAgreeDialog, checkSettlementRequest: checkSettlementRequest, openCompanyRegisterDialog: openCompanyRegisterDialog, setValue: setValue })] }));
}
exports.default = default_1;
